export default __webpack_public_path__ + "static/media/296.8f933c76.svg";